// extracted by mini-css-extract-plugin
export var box = "Header-module--box--10bb8";
export var layout = "Header-module--layout--a6d3f";
export var box_md = "Header-module--box_md--f1d77";
export var box_xmd = "Header-module--box_xmd--424af";
export var box_flex = "Header-module--box_flex--58460";
export var box_lg = "Header-module--box_lg--8bbb7";
export var box_sm = "Header-module--box_sm--8332a";
export var box_outer = "Header-module--box_outer--7b8ec";
export var box_whiteBg = "Header-module--box_white-bg--d824a";
export var box_noMarginBottom = "Header-module--box_no-margin-bottom--51995";
export var box_noPadding = "Header-module--box_no-padding--0de75";
export var box_outerGray = "Header-module--box_outer-gray--1d3ac";
export var box_dark = "Header-module--box_dark--b0fcd";
export var box_zIndex = "Header-module--box_z-index--88f5f";
export var box_zIndex6 = "Header-module--box_z-index-6--ce842";
export var box_eventsWithLine = "Header-module--box_events-with-line--a9314";
export var box_featuresAo = "Header-module--box_features-ao--be70e";
export var box_verticalPaddings = "Header-module--box_vertical-paddings--19507";
export var clearP = "Header-module--clearP--a308c";
export var clearP_vc = "Header-module--clearP_vc--4b353";
export var header = "Header-module--header--1b646";
export var fixed = "Header-module--fixed--e1e68";
export var logoWrap = "Header-module--logoWrap--c8d39";
export var logo = "Header-module--logo--84e3d";
export var whiteLogo = "Header-module--whiteLogo--9c07f";
export var navigation = "Header-module--navigation--9746d";
export var item = "Header-module--item--84724";
export var mobilePanel = "Header-module--mobilePanel--81516";
export var hiddenMg = "Header-module--hiddenMg--35480";
export var fadeInAnimation = "Header-module--fadeInAnimation--52037";
export var placeHolderShimmer = "Header-module--placeHolderShimmer--abb04";